"use strict";

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.replaceBehavior = exports.preKeyupBehavior = exports.preKeydownBehavior = exports.postKeyupBehavior = exports.keyupBehavior = exports.keypressBehavior = exports.keydownBehavior = void 0;

var _utils = require("../../utils");

var arrowKeys = _interopRequireWildcard(require("./arrow"));

var controlKeys = _interopRequireWildcard(require("./control"));

var characterKeys = _interopRequireWildcard(require("./character"));

var functionalKeys = _interopRequireWildcard(require("./functional"));

function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}

function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache(nodeInterop);

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

var replaceBehavior = [{
  matches: function matches(keyDef, element) {
    return keyDef.key === 'selectall' && (0, _utils.isElementType)(element, ['input', 'textarea']);
  },
  handle: function handle(keyDef, element, options, state) {
    var _state$carryValue;

    (0, _utils.setSelectionRange)(element, 0, ((_state$carryValue = state.carryValue) != null ? _state$carryValue : element.value).length);
  }
}];
exports.replaceBehavior = replaceBehavior;

var preKeydownBehavior = _toConsumableArray(functionalKeys.preKeydownBehavior);

exports.preKeydownBehavior = preKeydownBehavior;
var keydownBehavior = [].concat(_toConsumableArray(arrowKeys.keydownBehavior), _toConsumableArray(controlKeys.keydownBehavior), _toConsumableArray(functionalKeys.keydownBehavior));
exports.keydownBehavior = keydownBehavior;
var keypressBehavior = [].concat(_toConsumableArray(functionalKeys.keypressBehavior), _toConsumableArray(characterKeys.keypressBehavior));
exports.keypressBehavior = keypressBehavior;

var preKeyupBehavior = _toConsumableArray(functionalKeys.preKeyupBehavior);

exports.preKeyupBehavior = preKeyupBehavior;

var keyupBehavior = _toConsumableArray(functionalKeys.keyupBehavior);

exports.keyupBehavior = keyupBehavior;

var postKeyupBehavior = _toConsumableArray(functionalKeys.postKeyupBehavior);

exports.postKeyupBehavior = postKeyupBehavior;